export type ISODateTime = string;

import { format, parseISO } from 'date-fns';

export const dateToIsoDateTimeString = (date: Date): string =>
    format(date, "yyyy-MM-dd'T'HH:mm");

export const isoDateTimeStringToDate = (iso: string): Date => parseISO(iso);
